import axios from "../../index";
import { jobPostUrl } from "../../utils";

export const deleteJobPost = async (jobRequestId: string) => {
  return await axios.delete(jobPostUrl(jobRequestId));
};
